var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-main',{staticClass:"info-wrap"},[_c('div',{staticClass:"info-box"},[_c('div',[_c('div',{staticClass:"info-head tc"},[_c('h3',{staticClass:"info-title"},[_vm._v("品读文化（图书销售）")])]),_c('div',{staticClass:"info-content",domProps:{"innerHTML":_vm._s(_vm.infoText)}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }